'use client';

import { useEffect } from 'react';
import { interTight } from '@/lib/fonts';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <html lang="en" className={interTight.variable}>
      <body className="min-h-svh" style={{ background: '#07090F', color: '#E2E8F0' }}>
        <main className="grid min-h-screen place-items-center px-6 text-center">
          <div className="max-w-xl space-y-6">
            <p
              style={{ fontFamily: 'monospace', fontSize: '0.875rem', textTransform: 'uppercase', letterSpacing: '0.1em', opacity: 0.5 }}
            >
              Error
            </p>
            <h1 style={{ fontSize: '2.25rem', fontWeight: 600 }}>
              Something went wrong.
            </h1>
            <p style={{ opacity: 0.6 }}>
              An unexpected error occurred. The team has been notified.
            </p>
            <button
              type="button"
              onClick={reset}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.5rem',
                borderRadius: '9999px',
                background: 'hsl(202 78% 60%)',
                padding: '0.5rem 1.25rem',
                fontWeight: 500,
                color: '#07090F',
                cursor: 'pointer',
                border: 'none',
              }}
            >
              Try again
            </button>
          </div>
        </main>
      </body>
    </html>
  );
}
